export default __webpack_public_path__ + "static/media/MoonDarkIcon.aed2d14e.svg";